export default __webpack_public_path__ + "static/media/location.888905a2.svg";